import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
	Container,
	Row,
	Col,
	Button,
	Card,
	CardBody,
	Alert,
	Input,
	InputGroup,
	InputGroupText
} from "reactstrap";
import { toast } from "react-toastify";

const CmsAssistantComplete = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [copied, setCopied] = useState(false);

	// Get data from location state
	const websiteId = location.state?.websiteId || "";
	const websiteURL = location.state?.websiteURL || "";
	const widgetApiKey = location.state?.widgetApiKey || "";

	useEffect(() => {
		if (!websiteId || !widgetApiKey) {
			navigate("/getStarted/cmsAssistant", { replace: true });
		}
	}, [websiteId, widgetApiKey, navigate]);

	const copyApiKey = () => {
		navigator.clipboard.writeText(widgetApiKey);
		setCopied(true);
		toast.success("API Key copied to clipboard!");
		setTimeout(() => setCopied(false), 2000);
	};

	const goToDashboard = () => {
		navigate("/user/dashboard", { replace: true });
	};

	return (
		<>
			<section className='choosePlatformHeader'>
				<div className='container'>
					<Row className="align-items-center justify-content-center">
						<Col xs={"auto"}>
							<h2 className='mt-5'>
								<span className="material-icons" style={{ fontSize: 40, color: '#28a745', verticalAlign: 'middle', marginRight: 10 }}>
									check_circle
								</span>
								Setup Complete!
							</h2>
							<p className='text-center text-muted'>Your CMS Assistant is ready to use</p>
						</Col>
					</Row>
				</div>
			</section>

			<Container className="pb-5 mt-4">
				<Row className="justify-content-center">
					<Col lg={8}>
						{/* API Key Card */}
						<Card className="mb-4 shadow-sm">
							<CardBody>
								<h5 className="mb-3">
									<span className="material-icons" style={{ verticalAlign: 'middle', marginRight: 8, color: '#5c50e6' }}>
										vpn_key
									</span>
									Your API Key
								</h5>
								<p className="text-muted mb-3">
									Use this API key to connect your CMS with ConversionBox for transferring content. Keep it secure and don't share it publicly.
								</p>
								<InputGroup>
									<Input
										type="text"
										value={widgetApiKey}
										readOnly
										style={{ 
											fontFamily: 'monospace', 
											fontSize: '14px',
											backgroundColor: '#f8f9fa'
										}}
									/>
									<InputGroupText 
										style={{ cursor: 'pointer', backgroundColor: copied ? '#28a745' : '#5c50e6', color: 'white', border: 'none' }}
										onClick={copyApiKey}
									>
										<span className="material-icons" style={{ fontSize: 20 }}>
											{copied ? 'check' : 'content_copy'}
										</span>
									</InputGroupText>
								</InputGroup>
							</CardBody>
						</Card>

						{/* Next Steps */}
						<Alert color="info" className="mb-4">
							<h6 className="alert-heading mb-2">
								<span className="material-icons" style={{ verticalAlign: 'middle', marginRight: 8 }}>
									lightbulb
								</span>
								Next Steps
							</h6>
							<ul className="mb-0 pl-3">
								<li>Configure your CMS integration using the API key</li>
								<li>Train your assistant with your content</li>
								<li>Monitor conversations from the dashboard</li>
							</ul>
						</Alert>

						{/* Action Buttons */}
						<div className="text-center">
							<Button 
								color="primary" 
								className="cta" 
								onClick={goToDashboard}
								style={{ minWidth: '200px' }}
							>
								Go to Dashboard
							</Button>
						</div>
					</Col>
				</Row>
			</Container>
		</>
	);
};

export default CmsAssistantComplete;
